import React, { useState } from "react";
import styled from "styled-components";
import moment from "moment";
import iconCheck from "../../../../../images/iconCheck.png";
import { PreviewSurveyPDF } from "./survey-pdf";
import Modal from "../../../../../components/modal";

const SurveyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 20px 0px;
  min-width: 500px;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 auto 10px auto;
`;

const Date = styled.p`
  font-size: 1rem;
  font-weight: 600;
  margin: 0 auto 10px auto;
  text-align: center;
`;

const Description = styled.p`
  font-size: 1rem;
  width: 100%;
  text-align: center;
`;

const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 20px 0px;
`;

const QuestionTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
`;

const QuestionDescription = styled.p`
  color: #555;
  font-size: 0.9rem !important;
`;

const Checkmark = styled.img`
  width: 26px;
  height: 26px;
  margin: 0 !important;
`;

const Circle = styled.div`
  border: 1px solid #555;
  width: 25px;
  height: 25px;
  border-radius: 50%;
`;

const Option = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
  gap: 10px;
  margin-bottom: 3px;
  p {
    margin: 0 !important;
  }
`;

const SurveyResponse = ({ data = {} }) => {
  const { survey_data, response_data } = data;
  const renderResponse = (question, response) => {
    switch (question.responseType) {
      case "text":
        return <p>{response.response}</p>;
      case "multiple_choice":
      case "checkbox":
        const options = question?.options?.map((option) => {
          const isChecked = response?.response.includes(option.id);
          return (
            <Option key={option.id}>
              {isChecked ? (
                <Checkmark src={iconCheck} alt="check" />
              ) : (
                <Circle />
              )}
              <p>{option.value}</p>
            </Option>
          );
        });
        return options;
      case "linear_scale":
        return <p>{response.response}</p>;
      default:
        return null;
    }
  };

  return (
    <SurveyContainer>
      <Date>{moment.utc(data?.created_at).format("MMM D, YYYY")}</Date>
      <Title>{survey_data?.title}</Title>
      <Description>{survey_data?.description}</Description>
      {survey_data?.questions?.map((question) => {
        const response = response_data.find(
          (r) => r.question_id === question.id
        );
        return (
          <QuestionContainer key={question.id}>
            <QuestionTitle>{question.title}</QuestionTitle>
            <QuestionDescription>{question.description}</QuestionDescription>
            {response ? (
              renderResponse(question, response)
            ) : (
              <p style={{ fontStyle: "italic" }}>No response</p>
            )}
          </QuestionContainer>
        );
      })}
    </SurveyContainer>
  );
};

export const SurveyModal = ({ open, onClose, data = {} }) => {
  const [openPDF, setOpenPDF] = useState(false);

  return (
    <>
      <Modal
        open={open}
        onClose={() => onClose()}
        handleSubmit={() => setOpenPDF(true)}
        submitLabel="Export as PDF"
      >
        {data && <SurveyResponse data={data} />}
      </Modal>
      <PreviewSurveyPDF
        open={openPDF}
        handleClose={() => setOpenPDF(false)}
        data={data}
      />
    </>
  );
};
